export enum ArticleIncidentType {
    Missing,
    Damaged,
    Technical,
    Data
}